import { usePreview } from 'gatsby-theme-vehicles/src/components/preview/provider';
import mapSpecs from 'gatsby-theme-vehicles/src/components/map-specs';

// This hooks is for easy overriding the specs component
const useSpecs = () => {
  const {
    buildyear,
    baseColor,
    odometer,
    fuel,
  } = usePreview();
  return mapSpecs({
    odometer,
    fuel,
    buildyear,
    baseColor,
  }, {
    useShortValues: [
      'odometer',
      'fuel',
    ],
  });
};

export default useSpecs;
